/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Today_Toast_DetailInputs */

const en_us2_swap_today_toast_detail = /** @type {(inputs: Swap_Today_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At the end of the workout you decide whether it goes into the plan.`)
};

const pt_br2_swap_today_toast_detail = /** @type {(inputs: Swap_Today_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fim do treino você decide se leva para o plano.`)
};

const es_419_swap_today_toast_detail = /** @type {(inputs: Swap_Today_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al final del entrenamiento decides si pasa al plan.`)
};

const pt_pt2_swap_today_toast_detail = /** @type {(inputs: Swap_Today_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fim do treino decides se passa para o plano.`)
};

const fr_fr2_swap_today_toast_detail = /** @type {(inputs: Swap_Today_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la fin de la séance, tu décides s'il entre dans le programme.`)
};

const de_de2_swap_today_toast_detail = /** @type {(inputs: Swap_Today_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Ende des Trainings entscheidest du, ob sie in den Plan kommt.`)
};

const it_it2_swap_today_toast_detail = /** @type {(inputs: Swap_Today_Toast_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A fine allenamento decidi se portarlo nella scheda.`)
};

/**
* | output |
* | --- |
* | "At the end of the workout you decide whether it goes into the plan." |
*
* @param {Swap_Today_Toast_DetailInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_today_toast_detail = /** @type {((inputs?: Swap_Today_Toast_DetailInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Today_Toast_DetailInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_today_toast_detail(inputs)
	if (locale === "es-419") return es_419_swap_today_toast_detail(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_today_toast_detail(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_today_toast_detail(inputs)
	if (locale === "de-DE") return de_de2_swap_today_toast_detail(inputs)
	if (locale === "it-IT") return it_it2_swap_today_toast_detail(inputs)
	return en_us2_swap_today_toast_detail(inputs)
});
export { swap_today_toast_detail as "swap.today_toast_detail" }